<template>
  <div class="questionnaire-answer">
    <div class="survey-container">
      <div class="survey-info">
        <h1>
          {{
            surveyType === 1
              ? dataObj.templateQuestionnaireName
              : dataObj.questionnaireName
          }}
        </h1>
        <h4>
          {{
            surveyType === 1
              ? dataObj.templateQuestionnaireDescribe
              : dataObj.questionnaireDescribe
          }}
        </h4>
        <!-- <div>使用人数：{{ dataObj.useNum }}</div>
                  <div>题目数量：{{ dataObj.questionNum }}</div> -->
      </div>
      <!-- 问题列表 -->
      <div class="questions-list">
        <div v-for="(item, index) in dataList" :key="index" @click.stop="">
          <div class="item" v-if="item.type == QuestionType.SCQ">
            <div style="position: relative">
              <QuestionPreviewSCQ
                :params="{ data: item, index: index }"
                @update="updateAnswer"
              ></QuestionPreviewSCQ>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.MCQ">
            <div style="position: relative">
              <QuestionPreviewMCQ
                :params="{ data: item, index: index }"
                @update="updateAnswer"
              ></QuestionPreviewMCQ>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.SBQ">
            <div style="position: relative">
              <QuestionPreviewSBQ
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewSBQ>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.MBQ">
            <div style="position: relative">
              <QuestionPreviewMBQ
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewMBQ>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.DLQ">
            <div style="position: relative">
              <QuestionPreviewDLQ
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewDLQ>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.NPS">
            <div style="position: relative">
              <QuestionPreviewNPS
                :params="{ data: item, index: index }"
                @update="updateAnswer"
              ></QuestionPreviewNPS>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.QA">
            <div style="position: relative">
              <QuestionPreviewQA
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewQA>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.SRQ">
            <div style="position: relative">
              <QuestionPreviewSRQ
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewSRQ>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.VOTE">
            <div style="position: relative">
              <QuestionPreviewVote
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewVote>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.SORT">
            <div style="position: relative">
              <QuestionPreviewSort
                :params="{ data: item, index: index }"
                @update="updateAnswer"
              ></QuestionPreviewSort>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.SCORE">
            <div style="position: relative">
              <QuestionPreviewScore
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewScore>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.WRQ">
            <div style="position: relative">
              <QuestionPreviewWRQ
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewWRQ>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.REMARK">
            <div style="position: relative">
              <QuestionPreviewRemark
                :params="{ data: item, index: index }"
              ></QuestionPreviewRemark>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.NAME">
            <div style="position: relative">
              <QuestionPreviewName
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewName>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.GENDER">
            <div style="position: relative">
              <QuestionPreviewGender
                :params="{ data: item, index: index }"
                @update="updateAnswer"
              ></QuestionPreviewGender>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.AGE">
            <div style="position: relative">
              <QuestionPreviewAge
                :params="{ data: item, index: index }"
                @update="updateAnswer"
              ></QuestionPreviewAge>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.TEL">
            <div style="position: relative">
              <QuestionPreviewTel
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewTel>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.EMAIL">
            <div style="position: relative">
              <QuestionPreviewEmail
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewEmail>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.DATE">
            <div style="position: relative">
              <QuestionPreviewDate
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewDate>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.TIME">
            <div style="position: relative">
              <QuestionPreviewTime
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewTime>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.ADDR">
            <div style="position: relative">
              <QuestionPreviewAddress
                :params="{ data: item, index: index }"
              ></QuestionPreviewAddress>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.IMAGE">
            <div style="position: relative">
              <QuestionPreviewImage
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewImage>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.MaxDiff">
            <div style="position: relative">
              <QuestionPreviewMaxDiff
                :params="{ data: item, index: index }"
              ></QuestionPreviewMaxDiff>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.UploadFile">
            <div style="position: relative">
              <QuestionPreviewUploadFile
                :params="{ data: item, index: index }"
                :uuid="uuid"
                @update="updateAnswer"
              ></QuestionPreviewUploadFile>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.DownloadFile">
            <div style="position: relative">
              <QuestionPreviewDownloadFile
                :params="{ data: item, index: index }"
              ></QuestionPreviewDownloadFile>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.CASCADER">
            <div style="position: relative">
              <QuestionPreviewCASCADER
                :params="{ data: item, index: index }"
              ></QuestionPreviewCASCADER>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.BDQ">
            <div style="position: relative">
              <QuestionPreviewBDQ
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewBDQ>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.IDQ">
            <div style="position: relative">
              <QuestionPreviewIDQ
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewIDQ>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.ELQ">
            <div style="position: relative">
              <QuestionPreviewELQ
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewELQ>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.WX">
            <div style="position: relative">
              <QuestionPreviewWX
                :params="{ data: item, index: index }"
                :operate="'answer'"
                @update="updateAnswer"
              ></QuestionPreviewWX>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.TITLE">
            <div style="position: relative">
              <QuestionPreviewTitle
                :params="{ data: item, index: index }"
              ></QuestionPreviewTitle>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.ImageSCQ">
            <div style="position: relative">
              <QuestionPreviewImageScq
                :params="{ data: item, index: index }"
                @update="updateAnswer"
              ></QuestionPreviewImageScq>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.ImageMCQ">
            <div style="position: relative">
              <QuestionPreviewImageMcq
                :params="{ data: item, index: index }"
                @update="updateAnswer"
              ></QuestionPreviewImageMcq>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.MatrixSCQ">
            <div style="position: relative">
              <QuestionPreviewMatrixScq
                :params="{ data: item, index: index }"
              ></QuestionPreviewMatrixScq>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.MatrixMCQ">
            <div style="position: relative">
              <QuestionPreviewMatrixMcq
                :params="{ data: item, index: index }"
              ></QuestionPreviewMatrixMcq>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.ImageOrVideo">
            <div style="position: relative">
              <QuestionPreviewImageOrVideo
                :params="{ data: item, index: index }"
              ></QuestionPreviewImageOrVideo>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.Signature">
            <div style="position: relative">
              <QuestionPreviewSignature
                :params="{ data: item, index: index }"
              ></QuestionPreviewSignature>
              <div class="mask-div"></div>
            </div>
          </div>
          <div class="item" v-if="item.type == QuestionType.PageBreak">
            <div style="position: relative">
              <QuestionPreviewPageBreak
                :params="{ data: item, index: index }"
              ></QuestionPreviewPageBreak>
              <div class="mask-div"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PreviewComponents } from "@/utils/componentImports.js";
import {
  questionnaireTemplate,
  useQuestionnaireTemplate,
  questionnaireUpdateDetail,
  questionTempList,
  closeQuestionnaire,
  getUrlLink,
  generateQRCode,
  generateQRCodeWithLogo,
  questionnaireAnswer,
  checkQuestionnaire,
  questionnaireDetail,
} from "@/api/index.js";
export default {
  name: "QuestionnaireAnswer",
  components: {
    ...PreviewComponents,
  },
  data() {
    return {
      dataObj: {},
      dataList: [],
      answers: [],
      answerRecord: "",
      surveyType: null,
      QuestionType: this.$store.getters["questionType/getQuestionType"],
      // uuid: "uhzCFScM2BTZdKdO",
      uuid: "JSqnS3Mv9RKG3HoL",
      answerRecordId: null,
      isFreeAd: null,
    };
  },
  mounted() {
    this.checkQuestionInfo();
  },
  methods: {
    async checkQuestionInfo() {
      await checkQuestionnaire({
        uuid: this.uuid,
      })
        .then((res) => {
          console.log("res", res);
          if (res.code === 200) {
            this.queryDetail();
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    async queryDetail() {
      await questionnaireDetail({
        uuid: this.uuid, // 活动唯一标识",
        answerRecordId: this.answerRecordId,
      })
        .then((res) => {
          if (res.code === 200) {
            console.log("res111111111111111", res);

            this.loadingComplete = true;
            this.dataObj = res.data;
            this.isPage = res.data.isPage;
            // this.navigateTitle = res.data.data.questionnaireName
            // this.navigateTitle = copyrightAppletsName;
            this.consentContent = res.data.consentContent;
            this.ifQrCode = res.data.ifQrCode;
            this.processCount = res.data.schedule || 0;
            if (res.data.moduleList) {
              this.modules = res.data.moduleList.map((item) => {
                return {
                  ...item,
                  moduleContent: JSON.parse(item.moduleContent),
                };
              });
            }

            console.log("res.data", res.data);
            this.percentage = res.data.schedule;
            this.answerCount = res.data.answeredQuestionsNum;

            // if (this.operate !== "4") {
            //   if (
            //     this.dataObj.ifOneChance === "1" &&
            //     this.dataObj.isOver === 1
            //   ) {
            //     this.status = 3;
            //   } else {
            //     this.status = 4;
            //   }
            // }

            this.images = JSON.parse(res.data.questionnaireInformation);
            this.dataList = res.data.questionList.map((item) => {
              return {
                ...item,
                if_hide: 0,
                status: this.status,
              };
            });
            this.dataList = this.dataList.map((item) => {
              if (item.type === this.QuestionType.SRQ) {
                item.chooseList = JSON.stringify({
                  list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                    return {
                      ...temp,
                      context: item.scoreNum,
                    };
                  }),
                });
              }
              return item;
            });
            if (this.hasBreakPage) {
              // 分页处理
              this.pageList = [];
              let subList = [];
              // 遍历this.dataList，根据分页线分割
              this.dataList.forEach((item, index) => {
                if (item.type === this.QuestionType.PageBreak) {
                  // 当前页结束，添加到pageList并开始新页
                  if (subList.length > 0) {
                    this.pageList.push(subList);
                    subList = [];
                  }
                } else {
                  // 添加到当前页
                  subList.push(index);
                }
              });
              // 添加最后一页
              if (subList.length > 0) {
                this.pageList.push(subList);
              }

              this.beginIndex = this.pageList[0][0];
              this.endIndex = this.pageList[0][this.pageList[0].length - 1];

              // 计算总页数
              this.totalPage = this.pageList.length;
            } else if (this.isPage === 1) {
              this.beginIndex = 0;
              this.endIndex = 0;
              this.totalPage = this.dataList.length;
            } else {
              this.beginIndex = 0;
              this.endIndex = this.dataList.length - 1;
            }
            this.releaseStatus = res.data.releaseStatus;
            // if (res.data.data.releaseStatus === 1) {
            //   this.sectionList = [
            //     {
            //       text: "重新编辑",
            //       url: "https://ossfastmake.mustke.com/qrCode/tupian/1743576458244.png",
            //     },
            //     {
            //       text: "结束问卷",
            //       url: "https://ossfastmake.mustke.com/qrCode/tupian/1743576482702.png",
            //     },
            //     {
            //       text: "分享转发",
            //       url: "https://ossfastmake.mustke.com/qrCode/tupian/1743576498738.png",
            //     },
            //   ];
            // } else {
            //   this.sectionList = [
            //     {
            //       text: "继续编辑",
            //       url: "https://ossfastmake.mustke.com/qrCode/tupian/1743576458244.png",
            //     },
            //     {
            //       text: "发布问卷",
            //       url: "https://ossfastmake.mustke.com/qrCode/tupian/1743576498738.png",
            //     },
            //   ];
            // }

            const array = this.dataObj.questionList;
            const answers =
              this.dataObj.answerRecord !== null
                ? JSON.parse(this.dataObj.answerRecord)
                : [];
            this.answerDisplay(array, answers);

            // 处理分页线显示页数
            let pageLineIndex = 0;
            let questionIndex = 0;
            for (let i = 0; i < this.dataList.length; i++) {
              if (this.dataList[i].type === this.QuestionType.PageBreak) {
                pageLineIndex++;
                this.dataList[i].pageLineIndex = pageLineIndex;
              } else {
                if (this.dataList[i].type !== this.QuestionType.TITLE) {
                  questionIndex++;
                  this.dataList[i].questionIndex = questionIndex;
                }
              }
            }

            // this.queryQuestionTempList();
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    answerDisplay(array, answers) {
      console.log("这个是问题列表：", array);
      console.log("这个是后台返回的答案：", answers);
      this.answers = [];
      // 初始化answers,构建出每道题目的答案数据
      for (let i = 0; i < array.length; i++) {
        if (answers[i] !== null && answers[i] !== undefined) {
          answers[i].if_hide = 0;
          this.answers.push(answers[i]);
        } else {
          if (array[i].type === this.QuestionType.MCQ) {
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: [],
            });
          } else if (array[i].type === this.QuestionType.SBQ) {
            const num = array[i].caseProblem.split("____").length - 1;
            // 构建答案数据
            let answer = [];
            for (let j = 0; j < num; j++) {
              answer.push({
                id: "",
                context: "",
              });
            }
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: answer,
            });
          } else if (array[i].type === this.QuestionType.IMAGE) {
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: [],
            });
          } else if (
            array[i].type === this.QuestionType.MatrixSCQ ||
            array[i].type === this.QuestionType.MatrixMCQ
          ) {
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: JSON.parse(array[i].chooseList).list.map((item) => {
                return {
                  id: item.id,
                  oneId: "",
                  twoId: "",
                  threeId: "",
                };
              }),
            });
          } else {
            this.answers.push({
              question_id: array[i].id,
              type: array[i].type,
              if_hide: 0,
              answer: [],
            });
          }
        }
      }
      console.log("这个是构建的数据答案：", this.answers);
      // 遍历每道题目的答案数据,把答案数据渲染到this.dataList里面
      this.hasBreakPage = array.some(
        (item) => item.type === this.QuestionType.PageBreak,
      );
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        const answerItem =
          this.answers.find(
            (a) => parseInt(a.question_id) === parseInt(item.id),
          ) === undefined
            ? {
                question_id: item.id,
                type: array[i].type,
                if_hide: 0,
                answer: [],
              }
            : this.answers.find(
                (a) => parseInt(a.question_id) === parseInt(item.id),
              );
        // console.log("这是answer", answerItem, i);
        switch (item.type) {
          case this.QuestionType.SCQ:
            console.log("这是SCQ", item, answerItem);
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                    placeholder: temp.fill_prompt,
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                          ? answerItem.answer[0].context
                          : ""
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.MCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  const matched = answerItem.answer.find(
                    (a) => parseInt(a.id) === parseInt(temp.id),
                  );
                  return {
                    ...temp,
                    placeholder: temp.fill_prompt,
                    isChoose: !!matched,
                    fill_prompt:
                      matched && matched.context ? matched.context : "",
                  };
                }),
                minCount: JSON.parse(item.chooseList).minCount,
                maxCount: JSON.parse(item.chooseList).maxCount,
                isCountMust: JSON.parse(item.chooseList).isCountMust,
                isCountSwitch: JSON.parse(item.chooseList).isCountSwitch,
              }),
            };
            break;
          case this.QuestionType.SBQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              answer: answerItem.answer.map((temp) => {
                return {
                  id: temp.id,
                  context: temp.context,
                };
              }),
            };
            break;
          case this.QuestionType.SRQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    scoreNum:
                      answerItem.answer.length > 0
                        ? answerItem.answer[idx].context
                        : 1,
                    context:
                      answerItem.answer.length > 0
                        ? answerItem.answer[idx].context
                        : 0,
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.DLQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                  };
                }),
                value:
                  answerItem.answer.length > 0
                    ? answerItem.answer[0].context
                    : "",
              }),
            };
            break;
          case this.QuestionType.NPS:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? parseInt(answerItem.answer[0].context)
                  : -1,
            };
            break;
          case this.QuestionType.VOTE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              if_answer: answerItem.answer.length > 0,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  const matched = answerItem.answer.find(
                    (a) => parseInt(a.id) === parseInt(temp.id),
                  );
                  console.log(matched, "e121r1r12jhr12fr12rg21gr12r21ur21uir1");
                  return {
                    ...temp,
                    placeholder: temp.fill_prompt,
                    isChoose:
                      matched && matched.select ? matched.select === 1 : false,
                    fill_prompt:
                      matched && matched.context ? matched.context : "",
                    count: matched && matched.count ? matched.count : 0,
                    percentage:
                      matched && matched.percentage ? matched.percentage : 0,
                  };
                }),
                minCount: JSON.parse(item.chooseList).minCount,
                maxCount: JSON.parse(item.chooseList).maxCount,
                isCountMust: JSON.parse(item.chooseList).isCountMust,
                isCountSwitch: JSON.parse(item.chooseList).isCountSwitch,
              }),
            };
            break;
          case this.QuestionType.SORT:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, index) => {
                  return {
                    ...temp,
                    number:
                      answerItem.answer.length > 0
                        ? answerItem.answer[index].context
                        : "",
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.REMARK:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
            };
            break;
          case this.QuestionType.SCORE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, index) => {
                  return {
                    ...temp,
                    context:
                      answerItem.answer.length > 0
                        ? answerItem.answer[index].context
                        : 0,
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.MBQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    context:
                      answerItem.answer.length > 0
                        ? answerItem.answer[idx].context
                        : "",
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.QA:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.NAME:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.GENDER:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? answerItem.answer[0].context
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.AGE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                    fill_prompt:
                      answerItem.answer.length > 0
                        ? answerItem.answer[0].context
                        : "",
                  };
                }),
                count: JSON.parse(item.chooseList).count,
              }),
            };
            break;
          case this.QuestionType.TEL:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.EMAIL:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.DATE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.TIME:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.ADDR:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.WRQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  const matchedAnswer = (answerItem.answer || []).find(
                    (ans) => ans.id === temp.id,
                  );
                  return {
                    ...temp,
                    value: matchedAnswer ? matchedAnswer.context : "",
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.IMAGE:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: answerItem.answer.length > 0 ? answerItem.answer : [],
              }),
            };
            break;
          case this.QuestionType.MaxDiff:
            let parsedChoose = {};
            try {
              parsedChoose = JSON.parse(item.chooseList || "{}");
            } catch (e) {
              console.warn("chooseList parse error", e);
            }

            const list = (parsedChoose.list || []).map((temp) => ({
              id: temp.id || "",
              context: temp.context || temp.text || temp.name || "",
            }));

            const maxDiffList = (parsedChoose.maxDiffList || []).map(
              (group, pageIndex) => ({
                list: (group.list || []).map((temp) => {
                  const ans =
                    (answerItem.answer || []).find(
                      (a) => a.taskIndex === pageIndex + 1,
                    ) || {};
                  const leftId = String(ans.leftId || "");
                  const rightId = String(ans.rightId || "");
                  const tempId = String(temp.id || "");

                  return {
                    id: tempId,
                    context: temp.context || temp.text || temp.name || "",
                    choice:
                      leftId === tempId
                        ? "best"
                        : rightId === tempId
                        ? "worst"
                        : "",
                  };
                }),
              }),
            );

            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: {
                attributesNum: parsedChoose.attributesNum || 0,
                tasksNum: parsedChoose.tasksNum || 1,
                percentageTitle:
                  parsedChoose.percentageTitle ||
                  `${answerItem.headerBest || "满意"},${
                    answerItem.headerWorst || "不满意"
                  }`,
                list,
                maxDiffList,
              },
            };
            break;
          case this.QuestionType.UploadFile:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: (answerItem.answer || []).map((a) => ({
                  url: a.context,
                  name: a.name || a.context.split("/").pop(),
                })),
              }),
            };
            break;
          case this.QuestionType.DownloadFile:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: (() => {
                let list = [];
                try {
                  const parsed = JSON.parse(item.chooseList || "{}");
                  list = (parsed.list || []).map((temp) => ({
                    id: temp.id || "",
                    text: temp.text || "",
                    fileName: temp.fileName || "",
                  }));
                } catch (e) {
                  console.warn("chooseList parse error", e);
                }
                return JSON.stringify({ list });
              })(),
              list: (() => {
                try {
                  const parsed = JSON.parse(item.chooseList || "{}");
                  return (parsed.list || []).map((temp) => ({
                    id: temp.id || "",
                    text: temp.text || "",
                    fileName: temp.fileName || "",
                  }));
                } catch (e) {
                  return [];
                }
              })(),
            };
            break;
          case this.QuestionType.CASCADER:
            const parsedChooseList = (() => {
              try {
                return JSON.parse(item.chooseList) || {};
              } catch (e) {
                return { options: [] };
              }
            })();

            const processOptions = (options) => {
              return options.map((opt) => ({
                ...opt,
                children: opt.children
                  ? processOptions(opt.children)
                  : undefined,
              }));
            };

            const answerArr = answerItem.answer || [];
            const userAnswer = answerArr
              .map((a) => a.context)
              .filter(Boolean)
              .join(" / ");
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                options: processOptions(parsedChooseList.options || []),
                value: userAnswer,
              }),
            };
            break;
          case this.QuestionType.BDQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.IDQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.ELQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp) => {
                  return {
                    ...temp,
                  };
                }),
                value:
                  answerItem.answer.length > 0
                    ? answerItem.answer[0].context
                    : "",
              }),
            };
            break;
          case this.QuestionType.WX:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.MatrixSCQ:
            // this.dataList[i] = item
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    oneId: answerItem.answer[idx].oneId || "",
                    twoId: answerItem.answer[idx].twoId || "",
                    threeId: answerItem.answer[idx].threeId || "",
                  };
                }),
                verticalNum: JSON.parse(item.chooseList).verticalNum,
                horizontalTitle: JSON.parse(item.chooseList).horizontalTitle,
                percentageTitle: JSON.parse(item.chooseList).percentageTitle,
              }),
            };
            break;
          case this.QuestionType.MatrixMCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    oneId: answerItem.answer[idx].oneId || "",
                    twoId: answerItem.answer[idx].twoId || "",
                    threeId: answerItem.answer[idx].threeId || "",
                  };
                }),
                verticalNum: JSON.parse(item.chooseList).verticalNum,
                horizontalTitle: JSON.parse(item.chooseList).horizontalTitle,
                percentageTitle: JSON.parse(item.chooseList).percentageTitle,
              }),
            };
            break;
          case this.QuestionType.ImageSCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    isChoose:
                      answerItem.answer.length > 0
                        ? parseInt(answerItem.answer[0].id) ===
                          parseInt(temp.id)
                        : false,
                  };
                }),
              }),
            };
            break;
          case this.QuestionType.ImageMCQ:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              chooseList: JSON.stringify({
                list: JSON.parse(item.chooseList).list.map((temp, idx) => {
                  return {
                    ...temp,
                    isChoose: answerItem.answer.some((a) => {
                      return temp.id === a.id;
                    }),
                  };
                }),
                minCount: JSON.parse(item.chooseList).minCount,
                maxCount: JSON.parse(item.chooseList).maxCount,
                isCountMust: JSON.parse(item.chooseList).isCountMust,
                isCountSwitch: JSON.parse(item.chooseList).isCountSwitch,
              }),
            };
            break;
          case this.QuestionType.ImageOrVideo:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              context:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          case this.QuestionType.TITLE:
            // 标题
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
            };
            break;
          case this.QuestionType.PageBreak:
            this.dataList[i] = {
              ...item,
              if_hide: 0,
            };
            break;
          case this.QuestionType.Signature:
            this.dataList[i] = {
              ...item,
              if_hide: answerItem.if_hide,
              status: this.status,
              signatureImage:
                answerItem.answer.length > 0
                  ? answerItem.answer[0].context
                  : "",
            };
            break;
          default:
            break;
        }
      }

      console.log(
        "jhbberiubuigiufhewfhewufhweiufhweuifhweewiufehwiuhwuifhweuifhweiu",
        this.question_state,
        this.hasBreakPage,
        this.isPage,
      );
      if (this.hasBreakPage) {
        // 分页处理
        this.pageList = [];
        let subList = [];
        // 遍历this.dataList，根据分页线分割
        this.dataList.forEach((item, index) => {
          if (item.type === this.QuestionType.PageBreak) {
            // 当前页结束，添加到pageList并开始新页
            if (subList.length > 0) {
              this.pageList.push(subList);
              subList = [];
            }
          } else {
            // 添加到当前页
            subList.push(index);
          }
        });
        // 添加最后一页
        if (subList.length > 0) {
          this.pageList.push(subList);
        }

        this.beginIndex = this.pageList[0][0];
        this.endIndex = this.pageList[0][this.pageList[0].length - 1];

        // 计算总页数
        this.totalPage = this.pageList.length;
      } else if (this.isPage === 1) {
        this.beginIndex = 0;
        this.endIndex = 0;
        this.totalPage = this.dataList.length;
      } else {
        this.beginIndex = 0;
        this.endIndex = this.dataList.length - 1;
      }
      this.answerRecord = JSON.stringify(this.answers);
      console.log("答案答案答案答案：", this.answers);
      console.log("数据数据数据数据：", this.dataList);
      console.log("分页数据分页数据：", this.pageList);
      this.totalCount = this.dataList.filter(
        (item) => item.if_hide === 0,
      ).length;
    },
    updateAnswer(e) {
      console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", e);
      // 把当前题目的状态更新到this.dataList里面
      this.dataList[JSON.parse(e).index] = JSON.parse(e).data;
      // 把当前题目的答案更新到this.answers里面
      this.answers[JSON.parse(e).index] = JSON.parse(e).answer;

      console.log("查看逻辑设置：", JSON.parse(e).data.logicalJump);
      // 处理逻辑题的跳转，如果设置了逻辑
      if (
        JSON.parse(e).data.logicalJump !== "" &&
        JSON.parse(e).data.logicalJump !== null &&
        JSON.parse(e).data.logicalJump !== undefined
      ) {
        // 初始化
        this.dataList = this.dataList.map((item) => {
          return {
            ...item,
            if_hide: 0,
          };
        });

        // 获取当前题号
        const sortStart = JSON.parse(e).data.sort;
        // 获取跳转到的题号
        const rules = JSON.parse(JSON.parse(e).data.logicalJump).rules;
        const logical = rules.filter((item) => {
          return item.when[0] === JSON.parse(e).answer.answer[0].id;
        });
        console.log("地区无法去污粉v去我头发武器", logical);
        const sortEnd =
          logical[0].action === "end"
            ? this.dataList.length + 1
            : logical[0].targets[0];
        // 根据当前题号和跳转到的题号，把this.dataList里面的题号在当前题号和跳转到的题号之间的题目都隐藏起来
        // 把this.dataList里面的题号在当前题号和跳转到的题号之间的题目都设置if_hide为1
        // 把this.dataList里面的题号在跳转到的题号之后的题目都设置if_hide为0，其他的题目状态不变
        this.dataList = this.dataList.map((item) => {
          if (item.sort > sortStart && item.sort < sortEnd) {
            return {
              ...item,
              if_hide: 1,
            };
          } else if (item.sort >= sortEnd) {
            return {
              ...item,
              if_hide: 0,
            };
          } else {
            return item;
          }
        });
        // 清空this.dataList里面题号在跳转到的题号之后的题目的答案数据
        this.dataList = clearQuestionAnswer(sortEnd);
        // 清空this.answers里面题号在跳转到的题号之后的题目的数据的答案
        this.answers = this.answers.map((item, index) => {
          return {
            ...item,
            if_hide: this.dataList.find((i) => i.id === item.question_id)
              .if_hide,
            answer: index > sortEnd ? [] : item.answer,
          };
        });
      }

      console.log("答题后的列表", this.dataList);
      console.log("答题后的数据", this.answers);

      // 获取页面上展示出来的题目数量
      this.totalCount = this.dataList.filter((item) => {
        return item.if_hide === 0;
      }).length;

      // 每次答题都要把this.answers里面的答案数据进行处理，把投票题的答案数据进行过滤，只把id和context取出来
      const answerRecord = this.answers.map((item) => {
        if (item.type === this.QuestionType.WRQ) {
          return {
            ...item,
            answer: item.answer
              .filter((i) => {
                return i.context !== "";
              })
              .map((temp) => {
                return {
                  id: temp.id,
                  context: temp.context,
                };
              }),
          };
        } else {
          return item;
        }
      });
      this.answerRecord = JSON.stringify(answerRecord);
      console.log("好哦好哦好哦好哦好哦好哦哈哈哦哦好哦", this.answerRecord);
      // 提交答案
      // if (this.status === 4) {
      //   submitAnswer();
      // }
      this.submitAnswer();
    },
    submitAnswer() {
      let remark = [];
      const questionList = this.dataList || [];
      if (questionList.length > 0) {
        remark = questionList
          .filter((item) => item.type === 24)
          .map((item) => ({
            id: item.id,
            chooseList:
              typeof item.chooseList === "string"
                ? JSON.parse(item.chooseList)
                : item.chooseList || {},
          }));
      }

      const payload = {
        uuid: this.uuid,
        isOver: 0,
        answerRecord: this.answerRecord,
        addTime: Date.now(),
        totalQuestionsNumber: this.dataList.filter(
          (item) =>
            item.if_hide === 0 &&
            item.type !== this.QuestionType.REMARK &&
            item.type !== this.QuestionType.TITLE &&
            item.type !== this.QuestionType.PageBreak &&
            item.type !== this.QuestionType.ImageOrVideo,
        ).length,
        isFreeAd: this.isFreeAd,
      };

      if (remark.length > 0) {
        payload.remark = JSON.stringify(remark);
      }

      questionnaireAnswer(payload)
        .then((res) => {
          console.log("res777777777777777777777777777777", res);
          if (res.code === 200) {
            // this.processCount = res.data.data.recordsRate;
            // this.percentage = res.data.data.recordsRate;
            // this.answerCount = res.data.data.answeredQuestionsNum;
            // this.answerId = res.data.data.id;
          } else {
            this.$message.error(res.data.msg || "");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.questionnaire-answer {
  width: 630px;
  box-sizing: border-box;
  margin: 0 auto;
  height: calc(100vh - 40px - 40px);
  overflow: hidden;
  overflow-y: auto;
}

.questions-list {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  background: #ffffff;
}

.item {
  margin-bottom: 10px;
}

.survey-info {
  /* flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background-color: #fff; */
  padding: 10px;
  box-sizing: border-box;
  background: #ffffff;

  h1 {
    width: 100%;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: Medium;
    text-align: left;
    color: #323b5a;
    text-align: center;
  }

  h4 {
    font-size: 13px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: Regular;
    text-align: left;
    color: #7e7e81;
    line-height: 18px;
  }
}

.mask-div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 100;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/QuestionnaireAnswer/index.vue